import Button from "components/Buttons/Button";
import React from "react";

const CallToAction = ({
  text = "Birghton Centro de Inglés, El Puente Hacia Tu Futuro",
  img = "https://brightonenglishcenter.edu.co/img/Contactanos.webp",
  bgColor = "#0d2334",
  textColor = "#ffff86",
  title = "¡No dejes pasar esta oportunidad! Regístrate ahora y marca la diferencia.",
  buttonText = "Escríbenos",
  buttonBgColor,
  buttonColor,
  linkTo
}) => {
  return (
    <div
      className="overflow-hidden w-full mx-auto rounded-lg rounded-tl-none flex flex-row gap-10"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <img
        className="object-cover w-1/2 h-full rounded-r-lg"
        src={img}
        alt={text}
        width={1080}
        height={734}
        loading="lazy"
        title={title}
      />
      <div className="w-1/2 flex flex-col gap-5 justify-center items-start pr-10">
        <h3
          className="text-4xl md:text-6xl font-bold font-Bebas tracking-wider"
          id="diagnostico"
        >
          {title}
        </h3>
        <p className="text-2xl ">
          <em>{text}</em>
        </p>
        <a
          href={linkTo}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={text}
        >
          <Button
            text={buttonText}
            bgColor={buttonBgColor}
            color={buttonColor}
          />
        </a>
      </div>
    </div>
  );
};

export default CallToAction;
